// import React, { useEffect, useState } from "react";
// import { Container, Row, Col, Card, Table } from "react-bootstrap";
// import axios from "axios";
// import {
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   Tooltip,
//   Legend,
//   PieChart,
//   Pie,
//   Cell,
//   ResponsiveContainer,
// } from "recharts";
// import {
//   BsCartCheck,
//   BsCurrencyDollar,
//   BsPeople,
//   BsPersonCheck,
// } from "react-icons/bs";
// import "./dashboard.css";

// const Dashboard = () => {
//   const [stats, setStats] = useState({
//     totalOrders: 0,
//     totalCommission: 0,
//     totalUsers: 0,
//     totalServitors: 0,
//     totalRevenue: 0,
//   });
//   const [monthlyOrders, setMonthlyOrders] = useState([]);
//   const [recentOrders, setRecentOrders] = useState([]);
//   const [servicePerformance, setServicePerformance] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   // Fetch data from backend
//   useEffect(() => {
//     const fetchDashboardData = async () => {
//       try {
//         // Fetch stats
//         const statsRes = await axios.get("http://localhost:4001/api/dashboard/stats");
//         setStats(statsRes.data);

//         // Fetch monthly orders data
//         const monthlyRes = await axios.get("http://localhost:4001/api/dashboard/monthly-orders");
//         setMonthlyOrders(monthlyRes.data);

//         // Fetch recent orders data
//         const recentRes = await axios.get("http://localhost:4001/api/dashboard/recent-orders");
//         setRecentOrders(recentRes.data);

//         // Fetch service performance data
//         const performanceRes = await axios.get("http://localhost:4001/api/dashboard/service-performance");
//         setServicePerformance(performanceRes.data);

//         setLoading(false);
//       } catch (err) {
//         console.error("Error fetching dashboard data:", err);
//         setError("Error fetching dashboard data.");
//         setLoading(false);
//       }
//     };

//     fetchDashboardData();
//   }, []);

//   if (loading) return <div>Loading...</div>;
//   if (error) return <div>{error}</div>;

//   // Calculate Remaining Payment using totalRevenue from stats
//   const remainingPayment = (stats.totalRevenue * 0.05) - stats.totalCommission;

//   // Prepare Pie Chart Data for commission distribution
//   const pieChartData = [
//     { name: "Commission Earned", value: stats.totalCommission },
//     { name: "Remaining Commission", value: remainingPayment },
//   ];

//   const COLORS = ["#36A2EB", "#FFCE56"];

//   // Prepare data for the Service Performance Bar Chart
//   const serviceData = [
//     {
//       name: "Homeclean",
//       totalOrders: servicePerformance.homeclean?.totalOrders || 0,
//       completedOrders: servicePerformance.homeclean?.completedOrders || 0,
//     },
//     {
//       name: "Electrician",
//       totalOrders: servicePerformance.electrician?.totalOrders || 0,
//       completedOrders: servicePerformance.electrician?.completedOrders || 0,
//     },
//     {
//       name: "Plumber",
//       totalOrders: servicePerformance.plumber?.totalOrders || 0,
//       completedOrders: servicePerformance.plumber?.completedOrders || 0,
//     },
//   ];

//   return (
//     <Container fluid className="dashboard-container">
//       {/* Top Cards */}
//       <Row className="mb-4">
//         {[
//           { title: "Total Orders", value: stats.totalOrders, icon: <BsCartCheck />, color: "#007bff" },
//           { title: "Total Commission", value: `${stats.totalCommission}৳`, icon: <BsCurrencyDollar />, color: "#28a745" },
//           { title: "Total Users", value: stats.totalUsers, icon: <BsPeople />, color: "#ffc107" },
//           { title: "Total Servitors", value: stats.totalServitors, icon: <BsPersonCheck />, color: "#dc3545" },
//         ].map((card, index) => (
//           <Col key={index} md={3}>
//             <Card className="stat-card">
//               <Card.Body style={{ borderLeft: `5px solid ${card.color}` }}>
//                 <div className="icon-box" style={{ backgroundColor: card.color }}>
//                   {card.icon}
//                 </div>
//                 <h5>{card.title}</h5>
//                 <h3>{card.value}</h3>
//               </Card.Body>
//             </Card>
//           </Col>
//         ))}
//       </Row>

//       {/* Charts Section */}
//       <Row>
//         <Col md={6}>
//           <Card className="chart-card">
//             <Card.Body>
//               <h5>Monthly Orders Completed</h5>
//               <ResponsiveContainer width="100%" height={300}>
//                 <BarChart data={monthlyOrders}>
//                   <XAxis dataKey="month" />
//                   <YAxis />
//                   <Tooltip />
//                   <Legend />
//                   <Bar dataKey="orders" fill="#007bff" />
//                 </BarChart>
//               </ResponsiveContainer>
//             </Card.Body>
//           </Card>
//         </Col>
//         <Col md={6}>
//           <Card className="chart-card">
//             <Card.Body>
//               <h5>Commission Distribution</h5>
//               <ResponsiveContainer width="100%" height={300}>
//                 <PieChart>
//                   <Pie data={pieChartData} cx="50%" cy="50%" outerRadius={100} label>
//                     {pieChartData.map((entry, index) => (
//                       <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
//                     ))}
//                   </Pie>
//                   <Tooltip />
//                 </PieChart>
//               </ResponsiveContainer>
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>

//       {/* Service Performance Bar Chart */}
//       <Row className="mt-4">
//         <Col>
//           <Card className="chart-card">
//             <Card.Body>
//               <h5>Service Performance Overview</h5>
//               <ResponsiveContainer width="100%" height={300}>
//                 <BarChart data={serviceData}>
//                   <XAxis dataKey="name" />
//                   <YAxis />
//                   <Tooltip />
//                   <Legend />
//                   <Bar dataKey="totalOrders" fill="#8884d8" name="Total Orders" />
//                   <Bar dataKey="completedOrders" fill="#82ca9d" name="Completed Orders" />
//                 </BarChart>
//               </ResponsiveContainer>
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>

//       {/* Service Ratings Table */}
//       <Row className="mt-4">
//         <Col>
//           <Card className="table-card">
//             <Card.Body>
//               <h5>Service Ratings</h5>
//               <Table striped bordered hover responsive>
//                 <thead>
//                   <tr>
//                     <th>Service</th>
//                     <th>Average Rating</th>
//                     <th>Review Count</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {["homeclean", "electrician", "plumber"].map((service, index) => (
//                     <tr key={index}>
//                       <td>{service.charAt(0).toUpperCase() + service.slice(1)}</td>
//                       <td>{parseFloat(servicePerformance[service]?.avgRating || 0).toFixed(1)}</td>
//                       <td>{servicePerformance[service]?.reviewCount || 0}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </Table>
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>

//       {/* Recent Orders Table */}
//       <Row className="mt-4">
//         <Col>
//           <Card className="table-card">
//             <Card.Body>
//               <h5>Recent Orders</h5>
//               <Table striped bordered hover responsive>
//                 <thead>
//                   <tr>
//                     <th>#</th>
//                     <th>Service</th>
//                     <th>Amount</th>
//                     <th>Status</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {recentOrders.map((order, index) => (
//                     <tr key={index}>
//                       <td>{order.id}</td>
//                       <td>{order.service}</td>
//                       <td>{order.amount}৳</td>
//                       <td>{order.status}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </Table>
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>
//     </Container>
//   );
// };

// export default Dashboard;












// import React, { useEffect, useState } from "react";
// import { Container, Row, Col, Card, Table } from "react-bootstrap";
// import axios from "axios";
// import {

//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   Tooltip,
//   Legend,
//   PieChart,
//   Pie,
//   Cell,
//   ResponsiveContainer,
// } from "recharts";
// import {
//   BsCartCheck,
//   BsCurrencyDollar,
//   BsPeople,
//   BsPersonCheck,
// } from "react-icons/bs";
// import "./dashboard.css";
// import { URL } from "../../../config";

// const Dashboard = () => {
//   const [stats, setStats] = useState({
//     totalOrders: 0,
//     totalCommission: 0,
//     totalUsers: 0,
//     totalServitors: 0,
//     totalRevenue: 0,
//   });
//   const [monthlyOrders, setMonthlyOrders] = useState([]);
//   const [recentOrders, setRecentOrders] = useState([]);
//   const [servicePerformance, setServicePerformance] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   // Fetch data from backend
//   useEffect(() => {
//     const fetchDashboardData = async () => {
//       try {
//         // Fetch stats
//         const statsRes = await axios.get(`${URL}/api/dashboard/stats`);
//         setStats(statsRes.data);

//         // Fetch monthly orders data
//         const monthlyRes = await axios.get(`${URL}/api/dashboard/monthly-orders`);
//         setMonthlyOrders(monthlyRes.data);

//         // Fetch recent orders data
//         const recentRes = await axios.get(`${URL}/api/dashboard/recent-orders`);
//         setRecentOrders(recentRes.data);

//         // Fetch service performance data
//         const performanceRes = await axios.get(`${URL}/api/dashboard/service-performance`);
//         setServicePerformance(performanceRes.data);

//         setLoading(false);
//       } catch (err) {
//         console.error("Error fetching dashboard data:", err);
//         setError("Error fetching dashboard data.");
//         setLoading(false);
//       }
//     };

//     fetchDashboardData();
//   }, []);

//   if (loading) return <div className="dashboard-loading">Loading...</div>;
//   if (error) return <div className="dashboard-error">{error}</div>;

//   // Calculate Remaining Payment using totalRevenue from stats
//   const remainingPayment = (stats.totalRevenue * 0.05) - stats.totalCommission;

//   // Prepare Pie Chart Data for commission distribution
//   const pieChartData = [
//     { name: "Commission Earned", value: stats.totalCommission },
//     { name: "Remaining Commission", value: remainingPayment },
//   ];

//   const COLORS = ["#36A2EB", "#FFCE56"];

//   // Prepare data for the Service Performance Bar Chart
//   const serviceData = [
//     {
//       name: "Homeclean",
//       totalOrders: servicePerformance.homeclean?.totalOrders || 0,
//       completedOrders: servicePerformance.homeclean?.completedOrders || 0,
//       cancelledByServitor: servicePerformance.homeclean?.ordersCancelledByServitor || 0,
//       cancelledByUser: servicePerformance.homeclean?.ordersCancelledByUser || 0,
//       deadlineTimeout: servicePerformance.homeclean?.ordersDeadlineTimeout || 0,
//     },
//     {
//       name: "Electrician",
//       totalOrders: servicePerformance.electrician?.totalOrders || 0,
//       completedOrders: servicePerformance.electrician?.completedOrders || 0,
//       cancelledByServitor: servicePerformance.electrician?.ordersCancelledByServitor || 0,
//       cancelledByUser: servicePerformance.electrician?.ordersCancelledByUser || 0,
//       deadlineTimeout: servicePerformance.electrician?.ordersDeadlineTimeout || 0,
//     },
//     {
//       name: "Plumber",
//       totalOrders: servicePerformance.plumber?.totalOrders || 0,
//       completedOrders: servicePerformance.plumber?.completedOrders || 0,
//       cancelledByServitor: servicePerformance.plumber?.ordersCancelledByServitor || 0,
//       cancelledByUser: servicePerformance.plumber?.ordersCancelledByUser || 0,
//       deadlineTimeout: servicePerformance.plumber?.ordersDeadlineTimeout || 0,
//     },
//     {
//       name: "Gas Chula",
//       totalOrders:   servicePerformance.gasChula?.totalOrders           || 0,
//       completedOrders: servicePerformance.gasChula?.completedOrders     || 0,
//       cancelledByServitor: servicePerformance.gasChula?.ordersCancelledByServitor || 0,
//       cancelledByUser:      servicePerformance.gasChula?.ordersCancelledByUser    || 0,
//       deadlineTimeout:      servicePerformance.gasChula?.ordersDeadlineTimeout     || 0,
//     },

//     {
//     name: "AC Service",
//     totalOrders:          servicePerformance.acService?.totalOrders || 0,
//     completedOrders:      servicePerformance.acService?.completedOrders || 0,
//     cancelledByServitor:  servicePerformance.acService?.ordersCancelledByServitor || 0,
//     cancelledByUser:      servicePerformance.acService?.ordersCancelledByUser || 0,
//     deadlineTimeout:      servicePerformance.acService?.ordersDeadlineTimeout || 0,
//     },

//     {
//       name: "Filter",
//       totalOrders:         servicePerformance.filter?.totalOrders || 0,
//       completedOrders:     servicePerformance.filter?.completedOrders || 0,
//       cancelledByServitor: servicePerformance.filter?.ordersCancelledByServitor || 0,
//       cancelledByUser:     servicePerformance.filter?.ordersCancelledByUser || 0,
//       deadlineTimeout:     servicePerformance.filter?.ordersDeadlineTimeout || 0,
//     },

//     {
//      name: "Tutor Service",
//      totalOrders:          servicePerformance.tutorService?.totalOrders || 0,
//      completedOrders:      servicePerformance.tutorService?.completedOrders || 0,
//      cancelledByServitor:  servicePerformance.tutorService?.ordersCancelledByServitor || 0,
//      cancelledByUser:      servicePerformance.tutorService?.ordersCancelledByUser || 0,
//      deadlineTimeout:      servicePerformance.tutorService?.ordersDeadlineTimeout || 0,
//    },
//   ];

//   return (
//     <Container fluid className="dashboard-container">
//       {/* Updated: Top Stats Cards with specific class names for each card */}
//       <Row className="mb-4">
//         {[
//           { 
//             title: "Total Orders", 
//             value: stats.totalOrders, 
//             icon: <BsCartCheck />, 
//             className: "dashboard-orders-card" 
//           },
//           { 
//             title: "Total Commission", 
//             value: `${stats.totalCommission}৳`, 
//             icon: <BsCurrencyDollar />, 
//             className: "dashboard-commission-card" 
//           },
//           { 
//             title: "Total Users", 
//             value: stats.totalUsers, 
//             icon: <BsPeople />, 
//             className: "dashboard-users-card" 
//           },
//           { 
//             title: "Total Servitors", 
//             value: stats.totalServitors, 
//             icon: <BsPersonCheck />, 
//             className: "dashboard-servitors-card" 
//           },
//         ].map((card, index) => (
//           <Col key={index} md={3} sm={6} xs={12}>
//             <Card className={`dashboard-stats-card ${card.className}`}>
//               <Card.Body>
//                 <div className="dashboard-stats-icon">{card.icon}</div>
//                 <div className="dashboard-stats-title">{card.title}</div>
//                 <div className="dashboard-stats-value">{card.value}</div>
//               </Card.Body>
//             </Card>
//           </Col>
//         ))}
//       </Row>

//       {/* Updated: Chart Cards */}
//       <Row>
//         <Col md={6} xs={12}>
//           <Card className="dashboard-chart-card">
//             <Card.Body>
//               <h5 className="dashboard-chart-title">Monthly Orders Completed</h5>
//               <ResponsiveContainer width="100%" height={300}>
//                 <BarChart data={monthlyOrders}>
//                   <XAxis dataKey="month" />
//                   <YAxis />
//                   <Tooltip />
//                   <Legend />
//                   <Bar dataKey="orders" fill="#007bff" />
//                 </BarChart>
//               </ResponsiveContainer>
//             </Card.Body>
//           </Card>
//         </Col>
//         <Col md={6} xs={12}>
//           <Card className="dashboard-chart-card">
//             <Card.Body>
//               <h5 className="dashboard-chart-title">Commission Distribution</h5>
//               <ResponsiveContainer width="100%" height={300}>
//                 <PieChart>
//                   <Pie data={pieChartData} cx="50%" cy="50%" outerRadius={100} label>
//                     {pieChartData.map((entry, index) => (
//                       <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
//                     ))}
//                   </Pie>
//                   <Tooltip />
//                 </PieChart>
//               </ResponsiveContainer>
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>

//       {/* Updated: Service Performance Bar Chart */}
//       <Row className="mt-4">
//         <Col xs={12}>
//           <Card className="dashboard-chart-card">
//             <Card.Body>
//               <h5 className="dashboard-chart-title">Service Performance Overview</h5>
//               <ResponsiveContainer width="100%" height={300}>
//                 <BarChart data={serviceData}>
//                   <XAxis dataKey="name" />
//                   <YAxis />
//                   <Tooltip />
//                   <Legend />
//                   <Bar dataKey="totalOrders" fill="#8884d8" name="Total Orders" />
//                   <Bar dataKey="completedOrders" fill="#82ca9d" name="Completed Orders" />
//                   <Bar dataKey="cancelledByServitor" fill="#ff6666" name="Cancelled by Servitor" />
//                   <Bar dataKey="cancelledByUser"    fill="#ffa500" name="Cancelled by User" />
//                   <Bar dataKey="deadlineTimeout"    fill="#a9a9a9" name="Deadline Timeout" />
//                 </BarChart>
//               </ResponsiveContainer>
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>

//       {/* Updated: Service Ratings Table */}
//       <Row className="mt-4">
//         <Col xs={12}>
//           <Card className="dashboard-table-card">
//             <Card.Body>
//               <h5 className="dashboard-table-title">Service Ratings</h5>
//               <Table striped bordered hover responsive className="dashboard-table">
//                 <thead>
//                   <tr>
//                     <th>Service</th>
//                     <th>Average Rating</th>
//                     <th>Review Count</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {["homeclean", "electrician", "plumber", "gasChula", "acService", "filter", "tutorService"].map((service, index) => (
//                     <tr key={index}>
//                       <td>{service.charAt(0).toUpperCase() + service.slice(1)}</td>
//                       <td>{parseFloat(servicePerformance[service]?.avgRating || 0).toFixed(1)}</td>
//                       <td>{servicePerformance[service]?.reviewCount || 0}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </Table>
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>

//       {/* Updated: Recent Orders Table */}
//       <Row className="mt-4">
//         <Col xs={12}>
//           <Card className="dashboard-table-card">
//             <Card.Body>
//               <h5 className="dashboard-table-title">Recent Orders</h5>
//               <Table striped bordered hover responsive className="dashboard-table">
//                 <thead>
//                   <tr>
//                     <th>#</th>
//                     <th>Service</th>
//                     <th>Amount</th>
//                     <th>Status</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {recentOrders.map((order, index) => (
//                     <tr key={index}>
//                       <td>{order.id}</td>
//                       <td>{order.service}</td>
//                       <td>{order.amount}৳</td>
//                       <td>{order.status}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </Table>
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>
//     </Container>
//   );
// };

// export default Dashboard;





// ***** Updated Nicely design and add daily orders graph (20-Oct-2025) ***** //
// import React, { useEffect, useState } from "react";
// import { Container, Row, Col, Card, Table } from "react-bootstrap";
// import axios from "axios";
// import {
//   AreaChart,
//   Area,
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   Tooltip,
//   Legend,
//   PieChart,
//   Pie,
//   Cell,
//   ResponsiveContainer,
//   CartesianGrid,
// } from "recharts";
// import {
//   BsCartCheck,
//   BsCurrencyDollar,
//   BsPeople,
//   BsPersonCheck,
// } from "react-icons/bs";
// import "./dashboard.css";
// import { URL } from "../../../config";

// const PIE_COLORS = ["#10b981", "#87f0cdff"];

// // Custom legend for donut
// const DonutLegend = ({ payload, totals }) => {
//   const total = totals.totalCommission + totals.remaining;
//   const pct = (v) => (total ? `${((v / total) * 100).toFixed(1)}%` : "0%");
//   return (
//     <div className="dash-donut-legend">
//       {payload?.map((entry, idx) => {
//         const val = idx === 0 ? totals.totalCommission : totals.remaining;
//         return (
//           <div key={idx} className="dash-donut-legend-row">
//             <span className="dash-donut-dot" style={{ background: entry.color }} />
//             <span className="dash-donut-label">{entry.value}</span>
//             <span className="dash-donut-value">
//               {val.toFixed(2)}৳ <em>{pct(val)}</em>
//             </span>
//           </div>
//         );
//       })}
//     </div>
//   );
// };

// const Dashboard = () => {
//   const [stats, setStats] = useState({
//     totalOrders: 0,
//     totalCommission: 0,
//     totalUsers: 0,
//     totalServitors: 0,
//     totalRevenue: 0,
//   });

//   const [recentOrders, setRecentOrders] = useState([]);
//   const [servicePerformance, setServicePerformance] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   // Daily orders (7/14/30)
//   const [rangeDays, setRangeDays] = useState(30);
//   const [dailyOrders, setDailyOrders] = useState([]);

//   // Monthly orders (bar chart)
//   const [monthlyOrders, setMonthlyOrders] = useState([]);

//    useEffect(() => {
//       const adminToken = localStorage.getItem("adminToken");
  
//       if (!adminToken) {
//         setError("Not authorized. Please login as admin.");
//         setLoading(false);
//         return;
//       }
  
//       const headers = {
//         Authorization: `Bearer ${adminToken}`,
//       };
  
//       (async () => {
//         try {
//           // run in parallel
//           const [statsRes, recentRes, perfRes, monthlyRes] = await Promise.all([
//             axios.get(`${URL}/api/dashboard/stats`, { headers }),
//             axios.get(`${URL}/api/dashboard/recent-orders`, { headers }),
//             axios.get(`${URL}/api/dashboard/service-performance`, { headers }),
//             axios.get(`${URL}/api/dashboard/monthly-orders`, { headers }),
//           ]);
  
//           setStats(statsRes.data || {});
//           setRecentOrders(recentRes.data || []);
//           setServicePerformance(perfRes.data || {});
//           setMonthlyOrders(monthlyRes.data || []);
  
//           setLoading(false);
//         } catch (err) {
//           console.error("Error fetching dashboard data:", err);
//           if (err.response?.status === 401 || err.response?.status === 403) {
//             setError("Not authorized. Please login as admin.");
//           } else {
//             setError("Error fetching dashboard data.");
//           }
//           setLoading(false);
//         }
//       })();
//     }, []);
  
//     // fetch daily orders whenever range changes
//     useEffect(() => {
//       const adminToken = localStorage.getItem("adminToken");
//       if (!adminToken) return;
  
//       const headers = {
//         Authorization: `Bearer ${adminToken}`,
//       };
  
//       (async () => {
//         try {
//           const { data } = await axios.get(
//             `${URL}/api/dashboard/daily-orders`,
//             {
//               params: { days: rangeDays },
//               headers,
//             }
//           );
//           setDailyOrders(data || []);
//         } catch (e) {
//           console.error("daily-orders error:", e);
//         }
//       })();
//     }, [rangeDays]);

//   if (loading) return <div className="dashboard-loading">Loading...</div>;
//   if (error) return <div className="dashboard-error">{error}</div>;

//   // Commission donut data
//   const remainingPayment = Math.max(
//     0,
//     (stats.totalRevenue * 0.05) - (stats.totalCommission || 0)
//   );
//   const pieChartData = [
//     { name: "Commission Earned", value: stats.totalCommission || 0 },
//     { name: "Remaining Commission", value: remainingPayment },
//   ];

//   // Service performance bar (unchanged)
//   const serviceData = [
//     {
//       name: "Homeclean",
//       totalOrders: servicePerformance.homeclean?.totalOrders || 0,
//       completedOrders: servicePerformance.homeclean?.completedOrders || 0,
//       cancelledByServitor: servicePerformance.homeclean?.ordersCancelledByServitor || 0,
//       cancelledByUser: servicePerformance.homeclean?.ordersCancelledByUser || 0,
//       deadlineTimeout: servicePerformance.homeclean?.ordersDeadlineTimeout || 0,
//     },
//     {
//       name: "Electrician",
//       totalOrders: servicePerformance.electrician?.totalOrders || 0,
//       completedOrders: servicePerformance.electrician?.completedOrders || 0,
//       cancelledByServitor: servicePerformance.electrician?.ordersCancelledByServitor || 0,
//       cancelledByUser: servicePerformance.electrician?.ordersCancelledByUser || 0,
//       deadlineTimeout: servicePerformance.electrician?.ordersDeadlineTimeout || 0,
//     },
//     {
//       name: "Plumber",
//       totalOrders: servicePerformance.plumber?.totalOrders || 0,
//       completedOrders: servicePerformance.plumber?.completedOrders || 0,
//       cancelledByServitor: servicePerformance.plumber?.ordersCancelledByServitor || 0,
//       cancelledByUser: servicePerformance.plumber?.ordersCancelledByUser || 0,
//       deadlineTimeout: servicePerformance.plumber?.ordersDeadlineTimeout || 0,
//     },
//     {
//       name: "Gas Chula",
//       totalOrders:   servicePerformance.gasChula?.totalOrders || 0,
//       completedOrders: servicePerformance.gasChula?.completedOrders || 0,
//       cancelledByServitor: servicePerformance.gasChula?.ordersCancelledByServitor || 0,
//       cancelledByUser: servicePerformance.gasChula?.ordersCancelledByUser || 0,
//       deadlineTimeout: servicePerformance.gasChula?.ordersDeadlineTimeout || 0,
//     },
//     {
//       name: "AC Service",
//       totalOrders:          servicePerformance.acService?.totalOrders || 0,
//       completedOrders:      servicePerformance.acService?.completedOrders || 0,
//       cancelledByServitor:  servicePerformance.acService?.ordersCancelledByServitor || 0,
//       cancelledByUser:      servicePerformance.acService?.ordersCancelledByUser || 0,
//       deadlineTimeout:      servicePerformance.acService?.ordersDeadlineTimeout || 0,
//     },
//     {
//       name: "Filter",
//       totalOrders:         servicePerformance.filter?.totalOrders || 0,
//       completedOrders:     servicePerformance.filter?.completedOrders || 0,
//       cancelledByServitor: servicePerformance.filter?.ordersCancelledByServitor || 0,
//       cancelledByUser:     servicePerformance.filter?.ordersCancelledByUser || 0,
//       deadlineTimeout:     servicePerformance.filter?.ordersDeadlineTimeout || 0,
//     },
//     {
//       name: "Tutor Service",
//       totalOrders:          servicePerformance.tutorService?.totalOrders || 0,
//       completedOrders:      servicePerformance.tutorService?.completedOrders || 0,
//       cancelledByServitor:  servicePerformance.tutorService?.ordersCancelledByServitor || 0,
//       cancelledByUser:      servicePerformance.tutorService?.ordersCancelledByUser || 0,
//       deadlineTimeout:      servicePerformance.tutorService?.ordersDeadlineTimeout || 0,
//     },
//   ];

//   return (
//     <Container fluid className="dashboard-container">
//       {/* Stats */}
//       <Row className="mb-4">
//         {[
//           { title: "Total Orders", value: stats.totalOrders, icon: <BsCartCheck />, className: "dashboard-orders-card" },
//           { title: "Total Commission", value: `${stats.totalCommission}৳`, icon: <BsCurrencyDollar />, className: "dashboard-commission-card" },
//           { title: "Total Users", value: stats.totalUsers, icon: <BsPeople />, className: "dashboard-users-card" },
//           { title: "Total Servitors", value: stats.totalServitors, icon: <BsPersonCheck />, className: "dashboard-servitors-card" },
//         ].map((card, index) => (
//           <Col key={index} md={3} sm={6} xs={12}>
//             <Card className={`dashboard-stats-card ${card.className}`}>
//               <Card.Body>
//                 <div className="dashboard-stats-icon">{card.icon}</div>
//                 <div className="dashboard-stats-title">{card.title}</div>
//                 <div className="dashboard-stats-value">{card.value}</div>
//               </Card.Body>
//             </Card>
//           </Col>
//         ))}
//       </Row>

//       {/* Row 1: Daily Orders (full width) */}
//       <Row>
//         <Col xs={12}>
//           <Card className="dashboard-chart-card">
//             <Card.Body>
//               <div className="dash-chart-head">
//                 <div>
//                   <h5 className="dashboard-chart-title">Daily Orders</h5>
//                   <div className="dash-subtle">Last {rangeDays} days performance</div>
//                 </div>
//                 <div className="dash-range-tabs">
//                   {[30, 14, 7].map((d) => (
//                     <button
//                       key={d}
//                       className={`dash-range-btn ${rangeDays === d ? "active" : ""}`}
//                       onClick={() => setRangeDays(d)}
//                       type="button"
//                     >
//                       {d}D
//                     </button>
//                   ))}
//                 </div>
//               </div>

//               <div style={{ width: "100%", height: 340 }}>
//                 <ResponsiveContainer>
//                   <AreaChart data={dailyOrders} margin={{ top: 6, right: 8, left: 0, bottom: 0 }}>
//                     <defs>
//                       <linearGradient id="ordersFill" x1="0" y1="0" x2="0" y2="1">
//                         <stop offset="0%" stopColor="#10b981" stopOpacity={0.35} />
//                         <stop offset="95%" stopColor="#10b981" stopOpacity={0.02} />
//                       </linearGradient>
//                     </defs>
//                     <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
//                     <XAxis dataKey="label" tick={{ fontSize: 11, fill: "#6b7280" }} />
//                     <YAxis tick={{ fontSize: 11, fill: "#6b7280" }} />
//                     <Tooltip
//                       formatter={(v) => [v, "Orders"]}
//                       labelStyle={{ fontWeight: 700 }}
//                       contentStyle={{ borderRadius: 8, borderColor: "#e5e7eb" }}
//                     />
//                     <Area
//                       type="monotone"
//                       dataKey="orders"
//                       stroke="#10b981"
//                       strokeWidth={3}
//                       fill="url(#ordersFill)"
//                       dot={{ r: 3 }}
//                       activeDot={{ r: 5 }}
//                     />
//                   </AreaChart>
//                 </ResponsiveContainer>
//               </div>
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>

//       {/* Row 2: Monthly Orders (BAR) + Donut */}
//       <Row className="mt-3">
//         <Col md={8} xs={12}>
//           <Card className="dashboard-chart-card">
//             <Card.Body>
//               <h5 className="dashboard-chart-title">Monthly Orders</h5>
//               <div className="dash-subtle">Completed orders per month</div>
//               <div style={{ width: "100%", height: 320 }}>
//                 <ResponsiveContainer>
//                   <BarChart
//                     data={monthlyOrders}
//                     margin={{ top: 6, right: 10, left: 0, bottom: 0 }}
//                     barCategoryGap={18}
//                   >
//                     <defs>
//                       <linearGradient id="monthBarFill" x1="0" y1="0" x2="0" y2="1">
//                         <stop offset="0%" stopColor="#10b981" stopOpacity={0.95} />
//                         <stop offset="100%" stopColor="#10b981" stopOpacity={0.75} />
//                       </linearGradient>
//                     </defs>
//                     <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
//                     <XAxis dataKey="month" tick={{ fontSize: 12, fill: "#374151" }} />
//                     <YAxis tick={{ fontSize: 12, fill: "#374151" }} />
//                     <Tooltip
//                       formatter={(v) => [v, "Orders"]}
//                       labelStyle={{ fontWeight: 700 }}
//                       contentStyle={{ borderRadius: 8, borderColor: "#e5e7eb" }}
//                     />
//                     <Legend />
//                     <Bar
//                       dataKey="orders"
//                       name="Orders"
//                       fill="url(#monthBarFill)"
//                       radius={[10, 10, 0, 0]}
//                     />
//                   </BarChart>
//                 </ResponsiveContainer>
//               </div>
//             </Card.Body>
//           </Card>
//         </Col>

//         <Col md={4} xs={12}>
//           <Card className="dashboard-chart-card dash-donut-card">
//             <Card.Body>
//               <h5 className="dashboard-chart-title">Commission Distribution</h5>
//               <div className="dash-subtle mb-2">Earned vs remaining</div>

//               <div className="dash-donut-wrap">
//                 <ResponsiveContainer>
//                   <PieChart>
//                     <Pie
//                       data={pieChartData}
//                       dataKey="value"
//                       nameKey="name"
//                       innerRadius={75}
//                       outerRadius={115}
//                       paddingAngle={2}
//                       startAngle={90}
//                       endAngle={-270}
//                       labelLine={false}
//                     >
//                       {pieChartData.map((_, idx) => (
//                         <Cell key={idx} fill={PIE_COLORS[idx % PIE_COLORS.length]} />
//                       ))}
//                     </Pie>
//                     <Legend
//                       verticalAlign="bottom"
//                       align="center"
//                       content={
//                         <DonutLegend
//                           totals={{
//                             totalCommission: stats.totalCommission || 0,
//                             remaining: remainingPayment,
//                           }}
//                         />
//                       }
//                     />
//                     <Tooltip formatter={(v) => [`${Number(v).toFixed(2)}৳`, "Amount"]} />
//                   </PieChart>
//                 </ResponsiveContainer>
//               </div>
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>

//       {/* Service Performance */}
//       <Row className="mt-4">
//         <Col xs={12}>
//           <Card className="dashboard-chart-card">
//             <Card.Body>
//               <h5 className="dashboard-chart-title">Service Performance Overview</h5>
//               <ResponsiveContainer width="100%" height={300}>
//                 <BarChart data={serviceData}>
//                   <XAxis dataKey="name" />
//                   <YAxis />
//                   <Tooltip />
//                   <Legend />
//                   <Bar dataKey="totalOrders" fill="#8884d8" name="Total Orders" />
//                   <Bar dataKey="completedOrders" fill="#82ca9d" name="Completed Orders" />
//                   <Bar dataKey="cancelledByServitor" fill="#ff6666" name="Cancelled by Servitor" />
//                   <Bar dataKey="cancelledByUser"    fill="#ffa500" name="Cancelled by User" />
//                   <Bar dataKey="deadlineTimeout"    fill="#a9a9a9" name="Deadline Timeout" />
//                 </BarChart>
//               </ResponsiveContainer>
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>

//       {/* Service Ratings */}
//       <Row className="mt-4">
//         <Col xs={12}>
//           <Card className="dashboard-table-card">
//             <Card.Body>
//               <h5 className="dashboard-table-title">Service Ratings</h5>
//               <Table striped bordered hover responsive className="dashboard-table">
//                 <thead>
//                   <tr>
//                     <th>Service</th>
//                     <th>Average Rating</th>
//                     <th>Review Count</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {[
//                     "homeclean",
//                     "electrician",
//                     "plumber",
//                     "gasChula",
//                     "acService",
//                     "filter",
//                     "tutorService",
//                   ].map((service, index) => (
//                     <tr key={index}>
//                       <td>{service.charAt(0).toUpperCase() + service.slice(1)}</td>
//                       <td>{parseFloat(servicePerformance[service]?.avgRating || 0).toFixed(1)}</td>
//                       <td>{servicePerformance[service]?.reviewCount || 0}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </Table>
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>

//       {/* Recent Orders */}
//       <Row className="mt-4">
//         <Col xs={12}>
//           <Card className="dashboard-table-card">
//             <Card.Body>
//               <h5 className="dashboard-table-title">Recent Orders</h5>
//               <Table striped bordered hover responsive className="dashboard-table">
//                 <thead>
//                   <tr>
//                     <th>#</th>
//                     <th>Service</th>
//                     <th>Amount</th>
//                     <th>Status</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {recentOrders.map((order, index) => (
//                     <tr key={index}>
//                       <td>{order.id}</td>
//                       <td>{order.service}</td>
//                       <td>{order.amount}৳</td>
//                       <td>{order.status}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </Table>
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>
//     </Container>
//   );
// };

// export default Dashboard;






import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Table } from "react-bootstrap";
import axios from "axios";
import {
  AreaChart,
  Area,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";
import {
  BsCartCheck,
  BsCurrencyDollar,
  BsPeople,
  BsPersonCheck,
} from "react-icons/bs";
import "./dashboard.css";
import { URL } from "../../../config";

const PIE_COLORS = ["#10b981", "#87f0cdff"];

// Custom legend for donut
const DonutLegend = ({ payload, totals }) => {
  const total = totals.totalCommission + totals.remaining;
  const pct = (v) => (total ? `${((v / total) * 100).toFixed(1)}%` : "0%");
  return (
    <div className="dash-donut-legend">
      {payload?.map((entry, idx) => {
        const val = idx === 0 ? totals.totalCommission : totals.remaining;
        return (
          <div key={idx} className="dash-donut-legend-row">
            <span
              className="dash-donut-dot"
              style={{ background: entry.color }}
            />
            <span className="dash-donut-label">{entry.value}</span>
            <span className="dash-donut-value">
              {val.toFixed(2)}৳ <em>{pct(val)}</em>
            </span>
          </div>
        );
      })}
    </div>
  );
};

const Dashboard = () => {
  const [stats, setStats] = useState({
    totalOrders: 0,
    totalCommission: 0,
    totalUsers: 0,
    totalServitors: 0,
    totalRevenue: 0,
  });

  const [recentOrders, setRecentOrders] = useState([]);
  const [servicePerformance, setServicePerformance] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // Daily orders (7/14/30)
  const [rangeDays, setRangeDays] = useState(30);
  const [dailyOrders, setDailyOrders] = useState([]);

  // Monthly orders (bar chart)
  const [monthlyOrders, setMonthlyOrders] = useState([]);

  useEffect(() => {
    const adminToken = localStorage.getItem("adminToken");

    if (!adminToken) {
      setError("Not authorized. Please login as admin.");
      setLoading(false);
      return;
    }

    const headers = {
      Authorization: `Bearer ${adminToken}`,
    };

    (async () => {
      try {
        // run in parallel
        const [statsRes, recentRes, perfRes, monthlyRes] = await Promise.all([
          axios.get(`${URL}/api/dashboard/stats`, { headers }),
          axios.get(`${URL}/api/dashboard/recent-orders`, { headers }),
          axios.get(`${URL}/api/dashboard/service-performance`, { headers }),
          axios.get(`${URL}/api/dashboard/monthly-orders`, { headers }),
        ]);

        setStats(statsRes.data || {});
        setRecentOrders(recentRes.data || []);
        setServicePerformance(perfRes.data || {});
        setMonthlyOrders(monthlyRes.data || []);

        setLoading(false);
      } catch (err) {
        console.error("Error fetching dashboard data:", err);
        if (err.response?.status === 401 || err.response?.status === 403) {
          setError("Not authorized. Please login as admin.");
        } else {
          setError("Error fetching dashboard data.");
        }
        setLoading(false);
      }
    })();
  }, []);

  // fetch daily orders whenever range changes
  useEffect(() => {
    const adminToken = localStorage.getItem("adminToken");
    if (!adminToken) return;

    const headers = {
      Authorization: `Bearer ${adminToken}`,
    };

    (async () => {
      try {
        const { data } = await axios.get(
          `${URL}/api/dashboard/daily-orders`,
          {
            params: { days: rangeDays },
            headers,
          }
        );
        setDailyOrders(data || []);
      } catch (e) {
        console.error("daily-orders error:", e);
      }
    })();
  }, [rangeDays]);

  if (loading) return <div className="dashboard-loading">Loading...</div>;
  if (error) return <div className="dashboard-error">{error}</div>;

  // Commission donut data
  const remainingPayment = Math.max(
    0,
    (stats.totalRevenue * 0.05) - (stats.totalCommission || 0)
  );
  const pieChartData = [
    { name: "Commission Earned", value: stats.totalCommission || 0 },
    { name: "Remaining Commission", value: remainingPayment },
  ];

  // Service performance bar (unchanged data)
  const serviceData = [
    {
      name: "Homeclean",
      totalOrders: servicePerformance.homeclean?.totalOrders || 0,
      completedOrders: servicePerformance.homeclean?.completedOrders || 0,
      cancelledByServitor:
        servicePerformance.homeclean?.ordersCancelledByServitor || 0,
      cancelledByUser:
        servicePerformance.homeclean?.ordersCancelledByUser || 0,
      deadlineTimeout:
        servicePerformance.homeclean?.ordersDeadlineTimeout || 0,
    },
    {
      name: "Electrician",
      totalOrders: servicePerformance.electrician?.totalOrders || 0,
      completedOrders: servicePerformance.electrician?.completedOrders || 0,
      cancelledByServitor:
        servicePerformance.electrician?.ordersCancelledByServitor || 0,
      cancelledByUser:
        servicePerformance.electrician?.ordersCancelledByUser || 0,
      deadlineTimeout:
        servicePerformance.electrician?.ordersDeadlineTimeout || 0,
    },
    {
      name: "Plumber",
      totalOrders: servicePerformance.plumber?.totalOrders || 0,
      completedOrders: servicePerformance.plumber?.completedOrders || 0,
      cancelledByServitor:
        servicePerformance.plumber?.ordersCancelledByServitor || 0,
      cancelledByUser:
        servicePerformance.plumber?.ordersCancelledByUser || 0,
      deadlineTimeout:
        servicePerformance.plumber?.ordersDeadlineTimeout || 0,
    },
    {
      name: "Gas Chula",
      totalOrders: servicePerformance.gasChula?.totalOrders || 0,
      completedOrders: servicePerformance.gasChula?.completedOrders || 0,
      cancelledByServitor:
        servicePerformance.gasChula?.ordersCancelledByServitor || 0,
      cancelledByUser:
        servicePerformance.gasChula?.ordersCancelledByUser || 0,
      deadlineTimeout:
        servicePerformance.gasChula?.ordersDeadlineTimeout || 0,
    },
    {
      name: "AC Service",
      totalOrders: servicePerformance.acService?.totalOrders || 0,
      completedOrders: servicePerformance.acService?.completedOrders || 0,
      cancelledByServitor:
        servicePerformance.acService?.ordersCancelledByServitor || 0,
      cancelledByUser:
        servicePerformance.acService?.ordersCancelledByUser || 0,
      deadlineTimeout:
        servicePerformance.acService?.ordersDeadlineTimeout || 0,
    },
    {
      name: "Filter",
      totalOrders: servicePerformance.filter?.totalOrders || 0,
      completedOrders: servicePerformance.filter?.completedOrders || 0,
      cancelledByServitor:
        servicePerformance.filter?.ordersCancelledByServitor || 0,
      cancelledByUser:
        servicePerformance.filter?.ordersCancelledByUser || 0,
      deadlineTimeout:
        servicePerformance.filter?.ordersDeadlineTimeout || 0,
    },
    {
      name: "Tutor Service",
      totalOrders: servicePerformance.tutorService?.totalOrders || 0,
      completedOrders: servicePerformance.tutorService?.completedOrders || 0,
      cancelledByServitor:
        servicePerformance.tutorService?.ordersCancelledByServitor || 0,
      cancelledByUser:
        servicePerformance.tutorService?.ordersCancelledByUser || 0,
      deadlineTimeout:
        servicePerformance.tutorService?.ordersDeadlineTimeout || 0,
    },
  ];

  return (
    <Container fluid className="dashboard-container">
      {/* Stats */}
      <Row className="mb-4 dashboard-row-stats">
        {[
          {
            title: "Total Orders",
            value: stats.totalOrders,
            icon: <BsCartCheck />,
            className: "dashboard-orders-card",
          },
          {
            title: "Total Commission",
            value: `${stats.totalCommission}৳`,
            icon: <BsCurrencyDollar />,
            className: "dashboard-commission-card",
          },
          {
            title: "Total Users",
            value: stats.totalUsers,
            icon: <BsPeople />,
            className: "dashboard-users-card",
          },
          {
            title: "Total Servitors",
            value: stats.totalServitors,
            icon: <BsPersonCheck />,
            className: "dashboard-servitors-card",
          },
        ].map((card, index) => (
          <Col key={index} md={3} sm={6} xs={12} className="mb-3">
            <Card className={`dashboard-stats-card ${card.className}`}>
              <Card.Body>
                <div className="dashboard-stats-icon">{card.icon}</div>
                <div className="dashboard-stats-title">{card.title}</div>
                <div className="dashboard-stats-value">{card.value}</div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {/* Row 1: Daily Orders (full width) */}
      <Row>
        <Col xs={12}>
          <Card className="dashboard-chart-card">
            <Card.Body>
              <div className="dash-chart-head">
                <div>
                  <h5 className="dashboard-chart-title">Daily Orders</h5>
                  <div className="dash-subtle">
                    Last {rangeDays} days performance
                  </div>
                </div>
                <div className="dash-range-tabs">
                  {[30, 14, 7].map((d) => (
                    <button
                      key={d}
                      className={`dash-range-btn ${
                        rangeDays === d ? "active" : ""
                      }`}
                      onClick={() => setRangeDays(d)}
                      type="button"
                    >
                      {d}D
                    </button>
                  ))}
                </div>
              </div>

              <div className="dash-chart-wrapper dash-chart-wrapper--area">
                <ResponsiveContainer>
                  <AreaChart
                    data={dailyOrders}
                    margin={{ top: 6, right: 8, left: 0, bottom: 0 }}
                  >
                    <defs>
                      <linearGradient
                        id="ordersFill"
                        x1="0"
                        y1="0"
                        x2="0"
                        y2="1"
                      >
                        <stop
                          offset="0%"
                          stopColor="#10b981"
                          stopOpacity={0.35}
                        />
                        <stop
                          offset="95%"
                          stopColor="#10b981"
                          stopOpacity={0.02}
                        />
                      </linearGradient>
                    </defs>
                    <CartesianGrid
                      strokeDasharray="3 3"
                      stroke="#e5e7eb"
                    />
                    <XAxis
                      dataKey="label"
                      tick={{ fontSize: 11, fill: "#6b7280" }}
                    />
                    <YAxis
                      tick={{ fontSize: 11, fill: "#6b7280" }}
                    />
                    <Tooltip
                      formatter={(v) => [v, "Orders"]}
                      labelStyle={{ fontWeight: 700 }}
                      contentStyle={{
                        borderRadius: 8,
                        borderColor: "#e5e7eb",
                      }}
                    />
                    <Area
                      type="monotone"
                      dataKey="orders"
                      stroke="#10b981"
                      strokeWidth={3}
                      fill="url(#ordersFill)"
                      dot={{ r: 3 }}
                      activeDot={{ r: 5 }}
                    />
                  </AreaChart>
                </ResponsiveContainer>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Row 2: Monthly Orders (BAR) + Donut */}
      <Row className="mt-3">
        <Col md={8} xs={12} className="mb-3">
          <Card className="dashboard-chart-card">
            <Card.Body>
              <h5 className="dashboard-chart-title">Monthly Orders</h5>
              <div className="dash-subtle">Completed orders per month</div>
              <div className="dash-chart-wrapper dash-chart-wrapper--bar">
                <ResponsiveContainer>
                  <BarChart
                    data={monthlyOrders}
                    margin={{ top: 6, right: 10, left: 0, bottom: 0 }}
                    barCategoryGap={18}
                  >
                    <defs>
                      <linearGradient
                        id="monthBarFill"
                        x1="0"
                        y1="0"
                        x2="0"
                        y2="1"
                      >
                        <stop
                          offset="0%"
                          stopColor="#10b981"
                          stopOpacity={0.95}
                        />
                        <stop
                          offset="100%"
                          stopColor="#10b981"
                          stopOpacity={0.75}
                        />
                      </linearGradient>
                    </defs>
                    <CartesianGrid
                      strokeDasharray="3 3"
                      stroke="#e5e7eb"
                    />
                    <XAxis
                      dataKey="month"
                      tick={{ fontSize: 12, fill: "#374151" }}
                    />
                    <YAxis
                      tick={{ fontSize: 12, fill: "#374151" }}
                    />
                    <Tooltip
                      formatter={(v) => [v, "Orders"]}
                      labelStyle={{ fontWeight: 700 }}
                      contentStyle={{
                        borderRadius: 8,
                        borderColor: "#e5e7eb",
                      }}
                    />
                    <Legend />
                    <Bar
                      dataKey="orders"
                      name="Orders"
                      fill="url(#monthBarFill)"
                      radius={[10, 10, 0, 0]}
                    />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col md={4} xs={12} className="mb-3">
          <Card className="dashboard-chart-card dash-donut-card">
            <Card.Body>
              <h5 className="dashboard-chart-title">
                Commission Distribution
              </h5>
              <div className="dash-subtle mb-2">Earned vs remaining</div>

              <div className="dash-donut-wrap">
                <ResponsiveContainer>
                  <PieChart>
                    <Pie
                      data={pieChartData}
                      dataKey="value"
                      nameKey="name"
                      innerRadius={75}
                      outerRadius={115}
                      paddingAngle={2}
                      startAngle={90}
                      endAngle={-270}
                      labelLine={false}
                    >
                      {pieChartData.map((_, idx) => (
                        <Cell
                          key={idx}
                          fill={PIE_COLORS[idx % PIE_COLORS.length]}
                        />
                      ))}
                    </Pie>
                    <Legend
                      verticalAlign="bottom"
                      align="center"
                      content={
                        <DonutLegend
                          totals={{
                            totalCommission: stats.totalCommission || 0,
                            remaining: remainingPayment,
                          }}
                        />
                      }
                    />
                    <Tooltip
                      formatter={(v) => [
                        `${Number(v).toFixed(2)}৳`,
                        "Amount",
                      ]}
                    />
                  </PieChart>
                </ResponsiveContainer>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Service Performance */}
      <Row className="mt-4">
        <Col xs={12}>
          <Card className="dashboard-chart-card">
            <Card.Body>
              <h5 className="dashboard-chart-title">
                Service Performance Overview
              </h5>
              <div className="dash-chart-wrapper dash-chart-wrapper--service">
                <ResponsiveContainer>
                  <BarChart data={serviceData}>
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Bar
                      dataKey="totalOrders"
                      fill="#8884d8"
                      name="Total Orders"
                    />
                    <Bar
                      dataKey="completedOrders"
                      fill="#82ca9d"
                      name="Completed Orders"
                    />
                    <Bar
                      dataKey="cancelledByServitor"
                      fill="#ff6666"
                      name="Cancelled by Servitor"
                    />
                    <Bar
                      dataKey="cancelledByUser"
                      fill="#ffa500"
                      name="Cancelled by User"
                    />
                    <Bar
                      dataKey="deadlineTimeout"
                      fill="#a9a9a9"
                      name="Deadline Timeout"
                    />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Service Ratings */}
      <Row className="mt-4">
        <Col xs={12}>
          <Card className="dashboard-table-card">
            <Card.Body>
              <h5 className="dashboard-table-title">Service Ratings</h5>
              <Table
                striped
                bordered
                hover
                responsive
                className="dashboard-table"
              >
                <thead>
                  <tr>
                    <th>Service</th>
                    <th>Average Rating</th>
                    <th>Review Count</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    "homeclean",
                    "electrician",
                    "plumber",
                    "gasChula",
                    "acService",
                    "filter",
                    "tutorService",
                  ].map((service, index) => (
                    <tr key={index}>
                      <td>
                        {service.charAt(0).toUpperCase() +
                          service.slice(1)}
                      </td>
                      <td>
                        {parseFloat(
                          servicePerformance[service]?.avgRating || 0
                        ).toFixed(1)}
                      </td>
                      <td>
                        {servicePerformance[service]?.reviewCount || 0}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Recent Orders */}
      <Row className="mt-4">
        <Col xs={12}>
          <Card className="dashboard-table-card">
            <Card.Body>
              <h5 className="dashboard-table-title">Recent Orders</h5>
              <Table
                striped
                bordered
                hover
                responsive
                className="dashboard-table"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Service</th>
                    <th>Amount</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {recentOrders.map((order, index) => (
                    <tr key={index}>
                      <td>{order.id}</td>
                      <td>{order.service}</td>
                      <td>{order.amount}৳</td>
                      <td>{order.status}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Dashboard;
